export default __webpack_public_path__ + "static/media/Artboard 18.30aa81be.png";